export default __webpack_public_path__ + "static/media/pic.0fb35cf1.jpg";